module.exports = __webpack_public_path__ + "static/img/money.280fff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/money.png
// module id = lYLx
// module chunks = 1